import { ActionTypes } from "../constants";

const sanitise = (data) => (!data.dob || typeof data.dob === "string") ? data : {...data, dob: data.dob?.date || null};

const reduceAccount = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_ACCOUNT_SUBSCRIPTIONS:
            return {
                ...state,
                subscriptions: action.data
            };

        case ActionTypes.GET_ACCOUNT_PROFILE:
            return {
                ...state,
                profile: sanitise(action.data)
            };

        case ActionTypes.UPDATE_ACCOUNT_PROFILE_SUCCESS:
            return {
                ...state,
                profile: {
                    ...state.profile,
                    ...sanitise(action.payload)
                }
            };

        case ActionTypes.UPDATE_ACCOUNT_SECURITY_SUCCESS:
            return {
                ...state,
                profile: {
                    ...state.profile,
                    security: {
                        ...state.profile.security,
                        ...action.payload
                    }
                }
            };

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export const getSubscriptions = (account) => !!account ? account.subscriptions : null;
export const getProfile = (account) => !!account ? account.profile : null;

export default reduceAccount;